var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"change-question"},[_vm._v("请选择您遇到的问题类型")])}
var staticRenderFns = []

export { render, staticRenderFns }